import React, { useEffect, useState, useContext } from 'react';
import styled from 'styled-components';
import DetectorController, {
  HotelListType,
  HotelStoreType,
  StoreStatusModalData,
  StoreDayStatusLogType,
} from '../../../controller/DetectorController';
import PartnerController, {
  StoreStatusData,
  StoreMetaData,
  StoreLogData,
} from '../../../controller/PartnerController';
import Select from 'react-select';
import 'moment/locale/ko';
import moment from 'moment';
import StoreStatusModal from '../../../components/modal/storeStatusModal';
import DateTab from '../../../components/DateTab';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../navigation/TemporaryUserInfo';
import CustomTable from '../../../components/Table';
import Loading from '../../../components/Loading';

const PartnerStoreStatus = () => {
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);
  const nowDate = new Date();
  const currentHour = nowDate.getHours();
  const userData = localStorage.getItem('user');
  const userType = userData ? JSON.parse(userData).user_type : null;
  const [loading, setLoading] = useState(false);
  const [hotelList, setHotelList] = useState<HotelStoreType[]>([]);
  const [historyLog, setHistoryLog] = useState<StoreDayStatusLogType[]>([]);
  const [storeData, setStoreData] = useState<StoreStatusData[]>([]);

  const [todayDateTime, setTodayDateTime] = useState<string>('');
  const [modalOpne, setModalOpen] = useState<boolean>(false);
  const [isToday, setIsToday] = useState<boolean>(false);
  const [modalData, setModalData] = useState<StoreStatusModalData | null>(null);
  const [pauseStatus, setPauseStatus] = useState<number>();
  const [searchDate, setSearchDate] = useState<Date | null>(nowDate);
  const [resetToday, setResetToday] = useState<boolean>(false);
  const [selectedBcodes, setSelectedBcodes] = useState<string[]>([]);

  const formattedDate = moment(searchDate).format('YYYY-MM-DD');
  const todayDate = moment().format('YYYY-MM-DD');
  const hourData = [];
  if (formattedDate === todayDate) {
    for (let i = 0; i <= currentHour; i++) {
      hourData.push(i);
    }
  } else {
    for (let i = 0; i <= 23; i++) {
      hourData.push(i);
    }
  }

  const tableHeaders = {
    current: ['호텔이름', '입점 매장수', '영업중 매장수', '영업종료 매장수', '비정상 매장수'],
    history: ['호텔이름', '입점 매장수', '정상 매장수', '비정상 매장수', '미영업 매장수'],
  };

  // 오늘 호텔별 매장 영업 현황 표
  const renderHotelTableItem = () => {
    const totals = hotelList.reduce(
      (acc, data) => {
        acc.store_count += data.store_count || 0;
        acc.open_count += data.open_count || 0;
        acc.close_count += data.close_count || 0;
        acc.ab_normal_count += data.ab_normal_count || 0;
        return acc;
      },
      {
        store_count: 0,
        open_count: 0,
        close_count: 0,
        ab_normal_count: 0,
      },
    );
    return (
      <>
        {hotelList.map((data, dataIndex: number) => (
          <tr key={dataIndex} className="webTableWrap">
            <td>{data.hotel_name}</td>
            <td>{data.store_count}</td>
            <td>
              {data.open_count}
              <span>({Math.round((data.open_count / data.store_count) * 100)}%)</span>
            </td>
            <td>
              {data.close_count}
              <span>({Math.round((data.close_count / data.store_count) * 100)}%)</span>
            </td>
            <td>
              {data.ab_normal_count}
              <span>({Math.round((data.ab_normal_count / data.store_count) * 100)}%)</span>
            </td>
          </tr>
        ))}
        <tr style={{ borderTop: '2px solid #ddd' }}>
          <td>합계</td>
          <td>{totals.store_count}</td>
          <td>
            {totals.open_count}
            <span>({Math.round((totals.open_count / totals.store_count) * 100)}%)</span>
          </td>
          <td>
            {totals.close_count}
            <span>({Math.round((totals.close_count / totals.store_count) * 100)}%)</span>
          </td>
          <td>
            {totals.ab_normal_count}
            <span>({Math.round((totals.ab_normal_count / totals.store_count) * 100)}%)</span>
          </td>
        </tr>
      </>
    );
  };
  // 과거 호텔별 매장 영업 현황 표
  const renderHotelHistoryTableItem = () => {
    const totalStoreData = historyLog.map((data) => ({
      ...data,
      total: Number(data.noraml) + Number(data.abnormal) + Number(data.non),
    }));
    const totals = historyLog.reduce(
      (acc, data) => {
        const total = Number(data.noraml) + Number(data.abnormal) + Number(data.non);
        acc.noraml += Number(data.noraml) || 0;
        acc.abnormal += Number(data.abnormal) || 0;
        acc.non += Number(data.non) || 0;
        acc.store_count += total;
        return acc;
      },
      {
        store_count: 0,
        noraml: 0,
        abnormal: 0,
        non: 0,
      },
    );

    return (
      <>
        {totalStoreData.map((data, dataIndex) => (
          <tr key={dataIndex} className="webTableWrap">
            <td>{data.store_name}</td>
            <td>{data.total}</td>
            <td>
              {data.noraml}
              <span>
                ({data.total > 0 ? Math.round((Number(data.noraml) / data.total) * 100) : 0}%)
              </span>
            </td>
            <td>
              {data.abnormal}
              <span>
                ({data.total > 0 ? Math.round((Number(data.abnormal) / data.total) * 100) : 0}%)
              </span>
            </td>
            <td>
              {data.non}
              <span>
                ({data.total > 0 ? Math.round((Number(data.non) / data.total) * 100) : 0}%)
              </span>
            </td>
          </tr>
        ))}
        <tr style={{ borderTop: '2px solid #ddd' }}>
          <td>합계</td>
          <td>{totals.store_count}</td>
          <td>
            {totals.noraml}
            <span>
              ({totals.store_count > 0 ? Math.round((totals.noraml / totals.store_count) * 100) : 0}
              %)
            </span>
          </td>
          <td>
            {totals.abnormal}
            <span>
              (
              {totals.store_count > 0
                ? Math.round((totals.abnormal / totals.store_count) * 100)
                : 0}
              %)
            </span>
          </td>
          <td>
            {totals.non}
            <span>
              ({totals.store_count > 0 ? Math.round((totals.non / totals.store_count) * 100) : 0}%)
            </span>
          </td>
        </tr>
      </>
    );
  };
  // 호텔별 매장 영업 현황 표
  const TotalTable = () => {
    return (
      <>
        {loading ? (
          <Loading />
        ) : (
          <div className="totalHotelTable">
            {formattedDate === todayDate && todayDateTime && (
              <h2 className="tableHeader">{todayDateTime} 시 기준</h2>
            )}
            <CustomTable
              tableHeader={tableHeaders[formattedDate === todayDate ? 'current' : 'history']}
              renderTableItem={
                formattedDate === todayDate ? renderHotelTableItem : renderHotelHistoryTableItem
              }
              type="border"
            />
          </div>
        )}
      </>
    );
  };

  // 주소별 필터 검색
  const handleBcodeSelection = (bcodeName: string) => {
    setSelectedBcodes((prevSelected) =>
      prevSelected.includes(bcodeName)
        ? prevSelected.filter((item) => item !== bcodeName)
        : [...prevSelected, bcodeName],
    );
  };
  const handleSelectAll = () => {
    if (selectedBcodes.length === storeData.length) {
      setSelectedBcodes([]);
    } else {
      setSelectedBcodes(storeData.map((data: any) => data.bcode_name));
    }
  };
  const FilterArea = () => {
    return (
      <div className="areaListWrap">
        <button className="areaSortButton" onClick={handleSelectAll}>
          {selectedBcodes.length === storeData.length ? '전체 해제' : '전체 선택'}
        </button>
        <div className="areaList">
          {storeData.map((data: any, index: number) => (
            <div key={index} className="becodeList">
              <label htmlFor={data.bcode_name}>
                <input
                  type="checkbox"
                  id={data.bcode_name}
                  checked={selectedBcodes.includes(data.bcode_name)}
                  onChange={() => handleBcodeSelection(data.bcode_name)}
                />
                {data.bcode_name || '기타'}
              </label>
              <label htmlFor=""></label>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // 매장명 리스트
  const StoreNameList = ({ storeData, currentHour, formattedDate, todayDate }: any) => {
    const isStoreOffList = storeData
      .filter((data: StoreStatusData) => selectedBcodes.includes(data.bcode_name))
      .map((data: StoreStatusData) =>
        data.store_meta.map((metaData) => {
          return metaData.log.some(
            (log: any) =>
              log.hour === currentHour &&
              log.store_open_yn === 1 &&
              (log.store_login_yn === 0 || log.pause === 1),
          );
        }),
      );

    return (
      <div className="left">
        <div className="hourList"></div>
        {selectedBcodes.length > 0 &&
          storeData
            .filter((data: StoreStatusData) => selectedBcodes.includes(data.bcode_name))
            .map((data: StoreStatusData, index: number) => (
              <div key={index} className="storeAreaWrap">
                <div className="areaTitle">
                  <h3>{data.bcode_name === null ? '기타' : data.bcode_name}</h3>
                </div>
                {data.store_meta.map((metaData, metaIndex) => {
                  const isStoreOff =
                    formattedDate === todayDate && isStoreOffList[index][metaIndex];

                  return (
                    <div key={metaIndex} className="operatingTimeWrap title">
                      <button
                        onClick={() => {
                          openModal(metaData);
                        }}>
                        <img
                          src={`${process.env.PUBLIC_URL}/svg/ic_more.svg`}
                          alt="물음표 아이콘"
                          width={12}
                          height={12}
                        />
                      </button>
                      <h2 className={`storeName ${isStoreOff ? 'off' : ''}`}>
                        {metaData.store_name}
                      </h2>
                    </div>
                  );
                })}
              </div>
            ))}
      </div>
    );
  };

  // 매장 상태 리스트
  const StoreStatusList = ({ storeData, hourData }: any) => {
    const storList = storeData
      .flatMap((data: any) => data)
      .filter(
        (data: StoreStatusData) =>
          selectedBcodes.length === 0 || selectedBcodes.includes(data.bcode_name),
      );
    const renderStatus = (log: StoreLogData) => {
      if (log.store_availability_yn === 1) return <div className="activeStatus on">ON</div>;
      if (log.store_open_yn === 0 && log.store_availability_yn === 0)
        return <div className="activeStatus off">OFF</div>;
      if (log.store_open_yn === 1 && (log.store_login_yn === 0 || log.pause === 1)) {
        return (
          <div className="activeStatus error">
            <div className="errorIcon">
              {log.store_login_yn === 0 && (
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_pos_logout.svg`}
                  alt="로그아웃"
                  width={16}
                />
              )}
              {log.pause === 1 && (
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_pos_stop.svg`}
                  alt="일시정지"
                  width={9}
                  className="stop"
                />
              )}
            </div>
          </div>
        );
      }
      return null;
    };

    return (
      <div className="right">
        <div style={{ display: 'flex' }}>
          {selectedBcodes.length > 0 &&
            hourData.map((hour: number, hourIndex: number) => (
              <div key={hourIndex}>
                <div className="hourList">
                  <h3>{hour}시</h3>
                </div>
                {storList.map((data: StoreStatusData, storeIndex: number) => (
                  <div className="storeAreaWrap" key={storeIndex}>
                    <div className="areaTitle"></div>
                    {data.store_meta.map((store, idx) => (
                      <div key={idx}>
                        {store.log.some((log) => log.hour === hour) ? (
                          store.log
                            .filter((log) => log.hour === hour)
                            .map((log, logIndex) => (
                              <div key={logIndex} className="operatingTimeWrap">
                                {renderStatus(log)}
                              </div>
                            ))
                        ) : (
                          <div className="operatingTimeWrap nullData">N</div>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ))}
        </div>
      </div>
    );
  };

  const openModal = async (data: any) => {
    await getStoreList(data);
    setModalOpen(true);
  };
  const openPathLog = (startDate: Date | null, endDate: Date | null) => {
    getStoreStatusLogs(startDate, endDate);
    setSearchDate(startDate);
  };

  // 매장 상태값
  const getStoreStatusLogs = async (startDate: Date | null, endDate: Date | null) => {
    setStoreData([]);

    try {
      const oData = {
        start_date: moment(startDate).format('YYYY-MM-DD'),
        end_date: moment(endDate).format('YYYY-MM-DD'),
      };

      const response = await PartnerController.storeStatusLogs(oData);

      if (response && response.data.ok) {
        const resData = response.data.data;
        const uniqueStores = [];
        for (const key in resData) {
          if (resData.hasOwnProperty(key)) {
            const storeEntries = resData[key];
            if (storeEntries.length > 0) {
              uniqueStores.push(storeEntries);
            }
          }
        }
        setStoreData(resData);
      } else {
        if (response.data.msg === 'VERIFY_ERROR') {
          logout();
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  // 전체 호텔 리스트(오늘 날짜 통계표)
  const getHotelStoreTotal = async () => {
    try {
      const response = await DetectorController.getHotelStoreTotal();

      if (response && response.data) {
        console.log('getHotelStoreTotal', response.data.data);
        setHotelList(response.data.data);
        setTodayDateTime(moment().format('YYYY-MM-DD HH'));
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  // 과거 호텔 영엽 현황
  const getStoreDayStatusLogs = async () => {
    try {
      setLoading(true);
      const oData = {
        date: moment(searchDate).format('YYYY-MM-DD'),
      };
      const response = await DetectorController.storeDayStatusLogs(oData);

      if (response && response.data) {
        setHistoryLog(response.data.data);
      }
    } catch (err) {
      console.log('err-->', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (formattedDate === todayDate) {
      getHotelStoreTotal();
    } else {
      getStoreDayStatusLogs();
    }
  }, [searchDate]);

  // 매장 상세보기
  const getStoreList = async (data: any) => {
    const storeId = data.store_id;

    try {
      const response = await DetectorController.getStoreList(storeId);
      if (response && response.data) {
        setPauseStatus(response.data.data.pause);
        setModalData(response.data.data);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  useEffect(() => {
    getStoreStatusLogs(nowDate, nowDate);
  }, []);
  useEffect(() => {
    if (storeData.length > 0 && selectedBcodes.length === 0) {
      setSelectedBcodes(storeData.map((data: any) => data.bcode_name));
    }
  }, [storeData]);

  const StoreStatusGuide = () => {
    return (
      <div className="statusGuideBox">
        <div className="noticeText">
          <p>매시간 정각마다 매장 현황이 업데이트됩니다.</p>
          <h3>※관리 매장 조건※</h3>
          <p>
            현재시간과 가장 가까운 정각 기준 매장의 운영시간 내에 포스가 로그아웃되었거나 일시정지
            상태일 경우, 매장명이 강조되어 표시됩니다.
          </p>
        </div>
        <div className="statusGuide">
          <div className="row">
            <h2>포스 로그아웃</h2>
            <div className="activeStatus error">
              <div className="errorIcon">
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_pos_logout.svg`}
                  alt="로그아웃"
                  width={16}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <h2>포스 일시정지</h2>
            <div className="activeStatus error stop">
              <div className="errorIcon">
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_pos_stop.svg`}
                  alt="일시정지"
                  width={9}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <h2>영업중</h2>
            <div className="activeStatus on">ON</div>
          </div>
          <div className="row">
            <h2>영업시간 아님</h2>
            <div className="activeStatus off">ON</div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <Style>
      <div className="wrap">
        <button className="backButton" onClick={() => navigate('/dashboard')}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_home.svg`} alt="뒤로가기버튼" />
        </button>
        <h1>매장 영업 현황</h1>

        <div className="header">
          <div className="dateWrap">
            <DateTab type="oneDay" openPathLog={openPathLog} resetToday={resetToday} />
          </div>
          {userType === 0 && <TotalTable />}
          <StoreStatusGuide />
        </div>
        <FilterArea />
        <div className="contentWrap">
          <StoreNameList
            storeData={storeData}
            currentHour={currentHour}
            formattedDate={formattedDate}
            todayDate={todayDate}
          />
          <StoreStatusList storeData={storeData} hourData={hourData} />
        </div>
        <StoreStatusModal
          isVisible={modalOpne}
          setVisible={setModalOpen}
          modalData={modalData}
          pauseStatus={pauseStatus}
          setPauseStatus={setPauseStatus}
        />
      </div>
    </Style>
  );
};

export default PartnerStoreStatus;

const Style = styled.div`
  h1 {
    font-size: 24px;
    margin-bottom: 6px;
  }
  h2 {
    font-size: 14px;
    font-weight: 500;
  }
  h3 {
    font-size: 14px;
    font-weight: 500;
  }
  h4 {
    margin: 6px 0;
    font-size: 15px;
    font-weight: 400;
    color: #777777;
  }
  p {
    margin: 0;
    padding: 0;
  }
  button {
    border: none;
    outline: none;
    background: none;
    margin: 0;
    padding: 0;
  }
  .holiday {
    color: #ff0000;
    font-weight: 500;
  }
  .errorText {
    margin-top: 4px;
    font-size: 14px;
    font-weight: 500;
    color: #ff8080;
  }

  /* wrap */
  .wrap {
    width: 100%;
    max-width: 100%;
    padding: 30px 2vw;
  }

  /* areaListWrap */
  .areaListWrap {
    margin-top: 10px;
    padding: 16px 14px;
    border-radius: 5px;
    border: 1px solid #cecece;
    background: #fcfcfc;
    font-size: 14px;
  }
  .areaSortButton {
    padding: 4px 12px;
    margin-bottom: 10px;
    margin-right: 4px;
    border-radius: 50px;
    background: #fff;
    color: #333;
    border: 1px solid #4dd2ae;
  }
  .areaList {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 14px;
    flex-wrap: wrap;

    input {
      margin-right: 4px;
    }
    input[type='checkbox'] {
      accent-color: green;
    }
  }

  /* header */
  .header {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;

    .dateWrap {
      margin-top: 12px;
    }

    .activeStatus {
      max-width: 40px;
      min-width: 40px;
      border-radius: 4px;
      margin-left: 4px;
    }
    .activeStatus.error {
      img {
        left: 38%;
        bottom: 2%;
        height: 100%;
      }
    }
  }
  /* statusGuideBox */
  .statusGuideBox {
    padding: 12px;
    border-radius: 10px;
    background: #fff0f5;

    .noticeText {
      margin-bottom: 10px;
      p,
      h3 {
        color: #555;
      }

      h3 {
        margin-top: 10px;
      }
    }
    .statusGuide {
      display: flex;
      align-items: center;
      gap: 20px;
    }
  }

  /* storeNameWrap */
  .storeAreaWrap {
    margin-bottom: 10px;

    .areaTitle {
      height: 30px;
      margin: 4px 0;
      padding-top: 10px;
      border-top: 1px solid #eee;

      h3 {
        color: #000;
        font-weight: 700;
        font-size: 16px;
      }
    }
  }
  .operatingTimeWrap {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: #ebebeb;
    margin-bottom: 4px;
    height: 20px;
    gap: 4px;
  }
  .operatingTimeWrap.title {
    background: #fff;
  }
  .operatingTimeWrap.nullData {
    background: #fff;
    color: #fff;
  }
  .storeName {
    color: #979797;
    font-size: 14px;
  }

  .contentWrap {
    width: 100%;
    margin-top: 14px;
    display: flex;
    align-items: flex-start;

    .left {
      width: 12%;
    }
    .right {
      flex: 1;
      max-height: 100%;
      overflow-y: auto;
    }
  }

  .hourList {
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1px;
  }

  .storeName {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .storeName.off {
    font-weight: 500;
    color: #ff6060;
  }

  /* activeStatus */
  .activeStatus {
    min-width: 65px;
    max-width: 65px;
    display: ruby;
    margin: 0 1px;
  }
  .activeStatus.on {
    width: 100%;
    background: #4dd2ae;
    color: #4dd2ae;
    border-radius: 4px;
  }
  .activeStatus.off {
    background: #ebebeb;
    color: #ebebeb;
  }
  .activeStatus.error {
    position: relative;
    border-radius: 4px;
    background: #ff656d;

    .errorIcon {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
    }
  }

  /* totalHotelTable */
  .totalHotelTable {
    width: 50%;

    th {
      font-size: 14px;
    }
    td {
      font-size: 14px;
      text-align: center;
    }
    td span {
      color: #777;
      font-size: 12px;
    }
  }
  .tableHeader {
    margin-bottom: 4px;
    font-size: 12px;
    color: #777;
  }

  @media (max-width: 1300px) {
    h2 {
      font-size: 10px;
    }
    .header {
      .statusGuide {
        h2 {
          font-size: 10px;
        }
      }
      .activeStatus {
        max-width: 28px;
        min-width: 28px;
        gap: 4px;

        img {
          width: 12px;
        }
      }
      .activeStatus.stop {
        img {
          width: 8px;
        }
      }
    }
    .contentWrap {
      margin-top: 0px;

      .left {
        width: 20%;
      }
      .right {
        flex: 1;
      }
    }
    .hourList h3 {
      min-width: 25px;
      max-width: 25px;
      font-size: 10px;
      gap: 2px;
    }
    .activeStatus {
      min-width: 24px;
      max-width: 24px;
      display: ruby;
      margin: 0 1px;
      font-size: 12px;
      height: 20px;

      img {
        width: 10px;
      }
      .errorIcon {
        gap: 2px;
      }
      .errorIcon img.stop {
        width: 8px;
      }
    }
    .tabWrap {
      button {
        width: 33%;
      }
    }
  }
  @media (max-width: 700px) {
    .totalHotelTable {
      width: 100%;
    }
    .contentWrap {
      .left {
        width: 40%;
      }
    }
  }
`;
